const ClassData = {
  cleric: ['White', 'Grey', 'Black'],
  fighter: ['Berserker', 'Warrior', 'Paladin', 'Antipaladin', 'Ranger', 'Mercenary'],
  mage: ['Warlock', 'Necromancer', 'Wizard', 'Sorcerer', 'Druid', 'Illusionist', 'Healer'],
  monk: ['Priest', 'Healer', 'Scholar', 'Shaman'],
  rogue: ['Assassin', 'Bard', 'Thief'],
};

export default ClassData;
